export default function FeatureGrid() {
  const stats = [
    { value: '10,000+', label: '漫画资源', icon: 'ri-book-open-line', color: 'primary' },
    { value: '5,000万+', label: '月活用户', icon: 'ri-user-heart-line', color: 'accent' },
    { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line', color: 'secondary' },
    { value: '每日更新', label: '同步连载', icon: 'ri-refresh-line', color: 'primary' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="features-title">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">
            为什么选择我们
          </span>
          <h2
            id="features-title"
            className="mt-3 text-2xl md:text-4xl font-heading text-foreground-950"
          >
            虫虫漫画 · 你的专属漫画乐园
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            汇集全网最全漫画资源，打造极致阅读体验，让每一次翻页都充满期待
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="group p-6 md:p-8 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 ${
                  stat.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : stat.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading text-foreground-950 mb-2">
                {stat.value}
              </div>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}